// Keep permission/device bridge requests from hiding independently available preferences.
export function withPushTimeout(operation, message, timeoutMs = 12000, onTimeout) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => { onTimeout?.(); reject(new Error(message)); }, timeoutMs);
  });
  return Promise.race([Promise.resolve().then(operation), timeout]).finally(() => clearTimeout(timer));
}

export function loadPushSettings({ readPreferences, readStatus, readChildren, onPreferences, onStatus, onChildren, onFailure, timeoutMs = 12000 }) {
  const load = (operation, apply, section) => withPushTimeout(operation, `${section} timed out`, timeoutMs)
    .then(apply).catch(() => onFailure(section));
  // Each result becomes visible immediately, without waiting for the other native/network requests.
  return Promise.allSettled([
    load(readPreferences, onPreferences, 'preferences'),
    load(readStatus, onStatus, 'device'),
    ...(readChildren ? [load(readChildren, onChildren, 'children')] : []),
  ]);
}
